var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { dateToKey, keyToDate } from '../../date/date-picker-calculations';
import { assertWeek, localDateToLocalWeek, normalizeLocalWeek, weekToKey, } from '../../week/week-picker-calculations';
import { getDayNames } from '../display';
import { SdsDatePickerItem, } from '../sds-datepicker-item/sds-datepicker-item.lit';
import '../sds-datepicker-item/sds-datepicker-item.lit';
import { monthView } from '../utils';
import styles from './month-view.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsMonthView = (() => {
    var _SdsMonthView_currentDay_accessor_storage, _SdsMonthView_locale_accessor_storage, _SdsMonthView_weekNumbers_accessor_storage, _SdsMonthView_perWeekHover_accessor_storage, _SdsMonthView_statesMapper_accessor_storage, _SdsMonthView_weekStatesMapper_accessor_storage, _SdsMonthView_pageYear_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-month-view')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _weekNumbers_decorators;
    let _weekNumbers_initializers = [];
    let _weekNumbers_extraInitializers = [];
    let _perWeekHover_decorators;
    let _perWeekHover_initializers = [];
    let _perWeekHover_extraInitializers = [];
    let _statesMapper_decorators;
    let _statesMapper_initializers = [];
    let _statesMapper_extraInitializers = [];
    let _weekStatesMapper_decorators;
    let _weekStatesMapper_initializers = [];
    let _weekStatesMapper_extraInitializers = [];
    let _pageYear_decorators;
    let _pageYear_initializers = [];
    let _pageYear_extraInitializers = [];
    let _set_pageMonth_decorators;
    var SdsMonthView = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsMonthView_currentDay_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _currentDay_initializers, '')));
            _SdsMonthView_locale_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, _locale_initializers, 'en')));
            _SdsMonthView_weekNumbers_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _weekNumbers_initializers, false)));
            _SdsMonthView_perWeekHover_accessor_storage.set(this, (__runInitializers(this, _weekNumbers_extraInitializers), __runInitializers(this, _perWeekHover_initializers, false)));
            _SdsMonthView_statesMapper_accessor_storage.set(this, (__runInitializers(this, _perWeekHover_extraInitializers), __runInitializers(this, _statesMapper_initializers, () => 'none')));
            _SdsMonthView_weekStatesMapper_accessor_storage.set(this, (__runInitializers(this, _statesMapper_extraInitializers), __runInitializers(this, _weekStatesMapper_initializers, () => 'none')));
            _SdsMonthView_pageYear_accessor_storage.set(this, (__runInitializers(this, _weekStatesMapper_extraInitializers), __runInitializers(this, _pageYear_initializers, void 0)));
            this._pageMonth = __runInitializers(this, _pageYear_extraInitializers);
            this.handleHover = (event) => {
                const hoveredDetails = convertToHoverEvent(event);
                if (this.perWeekHover) {
                    this.updateRowHover(hoveredDetails);
                }
                this.dispatchEvent(new CustomEvent(SdsMonthView.HOVER_EVENT, {
                    detail: hoveredDetails,
                }));
            };
            this.handleMouseOut = () => this.cleanHover();
            this.itemClickHandler = (event) => {
                if (event.target instanceof SdsDatePickerItem) {
                    this.updateSelectedIdem(event.target.identifier);
                }
            };
            this.itemKeyPressHandler = (event) => {
                if (event.key === 'Enter' && event.target instanceof SdsDatePickerItem) {
                    this.updateSelectedIdem(event.target.identifier);
                }
            };
        }
        get currentDay() { return __classPrivateFieldGet(this, _SdsMonthView_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsMonthView_currentDay_accessor_storage, value, "f"); }
        get locale() { return __classPrivateFieldGet(this, _SdsMonthView_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsMonthView_locale_accessor_storage, value, "f"); }
        get weekNumbers() { return __classPrivateFieldGet(this, _SdsMonthView_weekNumbers_accessor_storage, "f"); }
        set weekNumbers(value) { __classPrivateFieldSet(this, _SdsMonthView_weekNumbers_accessor_storage, value, "f"); }
        get perWeekHover() { return __classPrivateFieldGet(this, _SdsMonthView_perWeekHover_accessor_storage, "f"); }
        set perWeekHover(value) { __classPrivateFieldSet(this, _SdsMonthView_perWeekHover_accessor_storage, value, "f"); }
        get statesMapper() { return __classPrivateFieldGet(this, _SdsMonthView_statesMapper_accessor_storage, "f"); }
        set statesMapper(value) { __classPrivateFieldSet(this, _SdsMonthView_statesMapper_accessor_storage, value, "f"); }
        get weekStatesMapper() { return __classPrivateFieldGet(this, _SdsMonthView_weekStatesMapper_accessor_storage, "f"); }
        set weekStatesMapper(value) { __classPrivateFieldSet(this, _SdsMonthView_weekStatesMapper_accessor_storage, value, "f"); }
        get pageYear() { return __classPrivateFieldGet(this, _SdsMonthView_pageYear_accessor_storage, "f"); }
        set pageYear(value) { __classPrivateFieldSet(this, _SdsMonthView_pageYear_accessor_storage, value, "f"); }
        set pageMonth(value) {
            const oldValue = this._pageMonth;
            this._pageMonth = value;
            this.requestUpdate('_pageMonth', oldValue);
        }
        render() {
            return html `
            <div
                class="${this.getClasses()}"
                style="grid-template-columns: repeat(${7 + (this.weekNumbers ? 1 : 0)}, 1fr);"
                id="content-container"
                @click="${this.itemClickHandler}"
                @keypress="${this.itemKeyPressHandler}"
                @mouseover="${this.handleHover}"
                @mouseout="${this.handleMouseOut}"
            >
                ${this.getHeaders()} ${this.renderItems()}
            </div>
        `;
        }
        async updated() {
            await this.updateComplete;
            this.setItems();
        }
        /**
         * state mapper for date, the result is delegated to sds-datepicker-item
         */
        setDateStateMapper(stateMapper) {
            this.statesMapper = stateMapper;
        }
        /**
         * state mapper for week, the result is delegated to sds-datepicker-item
         */
        setWeekStateMapper(stateMapper) {
            this.weekStatesMapper = stateMapper;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async firstUpdated() {
            await this.updateComplete;
            this.initContentContainer();
        }
        getClasses() {
            return classMap({
                'sds-date-picker__content': true,
                'sds-date-picker__content--lg': this.weekNumbers,
            });
        }
        getItemClasses() {
            return classMap({
                'sds-date-picker-item': true,
                'sds-date-picker-item--sm': !this.weekNumbers,
                'sds-date-picker-item--xs': this.weekNumbers,
            });
        }
        initContentContainer() {
            var _a;
            const contentContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#cont' + 'ent-container');
            if (contentContainer) {
                this._contentContainer = contentContainer;
            }
        }
        setItems() {
            this._items = Array.from(this._contentContainer.querySelectorAll('sds-datepicker-item').values());
        }
        getHeaders() {
            const headers = getDayNames(this.locale, 'short').map(day => html ` <div class="sds-date-picker__header-item">${day}</div>`);
            if (this.weekNumbers) {
                return [this.getFirstHeader()].concat(headers);
            }
            else {
                return headers;
            }
        }
        getFirstHeader() {
            const week = new Intl.DisplayNames(this.locale, {
                type: 'dateTimeField',
            }).of('weekOfYear');
            return html ` <div class="sds-date-picker__header-item sds-date-picker__header-item--week">
            ${week}
        </div>`;
        }
        updateSelectedIdem(identifier) {
            if (identifier.startsWith('week')) {
                this.updateSelectedWeek(identifier);
            }
            else {
                this.updateSelectedDate(identifier);
            }
            this.requestUpdate();
        }
        updateSelectedDate(selectedDate) {
            this.dispatchEvent(new CustomEvent(SdsMonthView.SELECT_EVENT, {
                detail: { date: keyToDate(selectedDate) },
            }));
        }
        updateSelectedWeek(weekIdentifier) {
            const week = getWeekNumber(weekIdentifier);
            this.dispatchEvent(new CustomEvent(SdsMonthView.WEEK_SELECT_EVENT, {
                detail: { week },
            }));
        }
        cleanHover() {
            this._items.forEach(item => item.classList.remove('sds-date-picker-item--hover'));
        }
        updateRowHover(hoveredDetails) {
            if (hoveredDetails.type === 'week') {
                this.hoverWeek(hoveredDetails.hoveredItem);
            }
            else if (hoveredDetails.type === 'date') {
                this.hoverWeek(localDateToLocalWeek(hoveredDetails.hoveredItem));
            }
            else {
                this.cleanHover();
            }
        }
        hoverWeek(week) {
            const nextWeek = normalizeLocalWeek(week[0], week[1] + 1);
            let selectedWeek = false;
            this._items.forEach(item => {
                if (item.identifier === 'week/' + weekToKey(...week)) {
                    item.classList.add('sds-date-picker-item--hover');
                    selectedWeek = true;
                }
                else if (item.identifier === 'week/' + weekToKey(...nextWeek)) {
                    item.classList.remove('sds-date-picker-item--hover');
                    selectedWeek = false;
                }
                else {
                    if (selectedWeek) {
                        item.classList.add('sds-date-picker-item--hover');
                    }
                    else {
                        item.classList.remove('sds-date-picker-item--hover');
                    }
                }
            });
        }
        renderItems() {
            return monthView(this.pageYear, this._pageMonth, this.weekNumbers).map((res, index) => {
                const line = res.days.map(day => this.getItemTemplate(...day));
                return res.week ? [this.getWeekTemplate(res.week, index, res.days)].concat(line) : line;
            });
        }
        getItemTemplate(year, month, day) {
            const key = dateToKey(year, month, day);
            const normalizedKey = this.normalizeDateForComparison(key);
            const normalizedCurrentDay = this.normalizeDateForComparison(this.currentDay);
            const isCurrent = normalizedKey === normalizedCurrentDay;
            const isUnavailable = month !== this._pageMonth;
            return html ` <sds-datepicker-item
            class="${this.getItemClasses()}"
            identifier="${key}"
            value="${day}"
            state="${this.statesMapper([year, month, day])}"
            ?current="${isCurrent}"
            ?unavailable="${isUnavailable}"
        >
        </sds-datepicker-item>`;
        }
        normalizeDateForComparison(dateString) {
            // Convert any date string to YYYY-MM-DD format for comparison
            // Handle both YYYY-MM-DD and YYYY/M/D formats
            const normalized = dateString.replace(/\//g, '-');
            // If it's already in YYYY-MM-DD format, return as is
            if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
                return normalized;
            }
            // If it's in YYYY-M-D format, zero-pad the month and day
            const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
            if (match) {
                const [, year, month, day] = match;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
            // If it doesn't match any expected format, return as is
            return normalized;
        }
        getWeekTemplate(week, rowIndex, days) {
            // 4th and 5th rows are unavailable only if all days are from next month
            const isUnavailable = rowIndex >= 4 && days[0][2] < 10;
            return html ` <sds-datepicker-item
            class="sds-date-picker-item sds-date-picker-item--week sds-date-picker-item--xs"
            identifier="week/${weekToKey(...week)}"
            value="${week[1]}"
            state="${this.weekStatesMapper(week)}"
            ?unavailable="${isUnavailable}"
        >
        </sds-datepicker-item>`;
        }
    };
    _SdsMonthView_currentDay_accessor_storage = new WeakMap();
    _SdsMonthView_locale_accessor_storage = new WeakMap();
    _SdsMonthView_weekNumbers_accessor_storage = new WeakMap();
    _SdsMonthView_perWeekHover_accessor_storage = new WeakMap();
    _SdsMonthView_statesMapper_accessor_storage = new WeakMap();
    _SdsMonthView_weekStatesMapper_accessor_storage = new WeakMap();
    _SdsMonthView_pageYear_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsMonthView");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _currentDay_decorators = [property()];
        _locale_decorators = [property()];
        _weekNumbers_decorators = [property({ type: Boolean, attribute: 'week-numbers' })];
        _perWeekHover_decorators = [property({ type: Boolean, attribute: 'per-week-hover' })];
        _statesMapper_decorators = [state()];
        _weekStatesMapper_decorators = [state()];
        _pageYear_decorators = [property({ type: Number })];
        _set_pageMonth_decorators = [property({
                type: Number,
                hasChanged: (pageMonth, oldValue) => pageMonth <= 12 && 1 <= pageMonth && oldValue !== pageMonth,
            })];
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _weekNumbers_decorators, { kind: "accessor", name: "weekNumbers", static: false, private: false, access: { has: obj => "weekNumbers" in obj, get: obj => obj.weekNumbers, set: (obj, value) => { obj.weekNumbers = value; } }, metadata: _metadata }, _weekNumbers_initializers, _weekNumbers_extraInitializers);
        __esDecorate(_classThis, null, _perWeekHover_decorators, { kind: "accessor", name: "perWeekHover", static: false, private: false, access: { has: obj => "perWeekHover" in obj, get: obj => obj.perWeekHover, set: (obj, value) => { obj.perWeekHover = value; } }, metadata: _metadata }, _perWeekHover_initializers, _perWeekHover_extraInitializers);
        __esDecorate(_classThis, null, _statesMapper_decorators, { kind: "accessor", name: "statesMapper", static: false, private: false, access: { has: obj => "statesMapper" in obj, get: obj => obj.statesMapper, set: (obj, value) => { obj.statesMapper = value; } }, metadata: _metadata }, _statesMapper_initializers, _statesMapper_extraInitializers);
        __esDecorate(_classThis, null, _weekStatesMapper_decorators, { kind: "accessor", name: "weekStatesMapper", static: false, private: false, access: { has: obj => "weekStatesMapper" in obj, get: obj => obj.weekStatesMapper, set: (obj, value) => { obj.weekStatesMapper = value; } }, metadata: _metadata }, _weekStatesMapper_initializers, _weekStatesMapper_extraInitializers);
        __esDecorate(_classThis, null, _pageYear_decorators, { kind: "accessor", name: "pageYear", static: false, private: false, access: { has: obj => "pageYear" in obj, get: obj => obj.pageYear, set: (obj, value) => { obj.pageYear = value; } }, metadata: _metadata }, _pageYear_initializers, _pageYear_extraInitializers);
        __esDecorate(_classThis, null, _set_pageMonth_decorators, { kind: "setter", name: "pageMonth", static: false, private: false, access: { has: obj => "pageMonth" in obj, set: (obj, value) => { obj.pageMonth = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsMonthView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.SELECT_EVENT = 'sds.sds-month-view.select';
    _classThis.WEEK_SELECT_EVENT = 'sds.sds-month-view.week.select';
    _classThis.HOVER_EVENT = 'sds.sds-month-view.hover';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsMonthView = _classThis;
})();
export { SdsMonthView };
function getWeekNumber(weekIdentifier) {
    const [_, yearStr, weekStr] = weekIdentifier.split('/');
    return [parseInt(yearStr), assertWeek(parseInt(weekStr))];
}
function convertToHoverEvent(event) {
    if (!(event.target instanceof SdsDatePickerItem)) {
        return {
            type: undefined,
            hoveredItem: undefined,
        };
    }
    else if (event.target.identifier.startsWith('week')) {
        return {
            type: 'week',
            hoveredItem: getWeekNumber(event.target.identifier),
        };
    }
    else {
        return {
            type: 'date',
            hoveredItem: keyToDate(event.target.identifier),
        };
    }
}
